import React, { useEffect, useState } from "react";
import { 
  Box,  
  Button,
  Chip,
  CircularProgress,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import "./styles.css";

const StudentGrading = ({ data }) => {

    const [gradePercentage, setGradePercentage] = useState(0);
    const [gradeColor, setGradeColor] = useState("");
    const [feedback, setFeedback] = useState("");
    const feedbackArr = ([
        {
            message: "Perfect! "
        },
        {
            message: "Amazing! "
        },
        {
            message: "Great job! "
        },
        {
            message: "Decent work! "
        },
        {
            message: "Not bad! "
        },
        {
            message: "Ok! "
        },
        {
            message: "Oh dear! "
        },
    ]);

    const [chips, setChips] = useState([]);

    const gradeSuccess = "rgb(15, 255, 19"
    const gradeSuccess2 = "rgb(147, 255, 15"
    const gradeSuccess3 = "rgb(207, 255, 15"
    const gradeWarning = "rgb(255, 251, 15"
    const gradeWarning2 = "rgb(255, 195, 15"
    const gradeWarning3 = "rgb(255, 143, 15"

    const gradeFail = "rgba(239, 83, 80"

    const min = 0;
    const max = 100;

console.log(data)
console.log(data[1].children[0].name)

    useEffect(() => {
        setGradePercentage(parseInt(Math.random() * (max - min) + min));

    },[])

    useEffect(() => {
        if(gradePercentage >= 95) {
            setGradeColor(gradeSuccess)
            setFeedback(feedbackArr[0].message)
            setChips([])
        }
        if(gradePercentage <= 90) {
            setGradeColor(gradeSuccess2)
            setFeedback(feedbackArr[1].message)
            if(data[0].children != undefined && data[1].children != undefined) {
                if(data[0].children[0].name != undefined) {
                    setChips([
                        {
                            name: data[0].children[0].name
                        },
                    ])
                } else {
                    // setChips([{name: data[0].name}])
                    setChips([])
                }
            } else {
                // setChips([{name: data[0].name}])
                setChips([])
            }
        }
        if(gradePercentage <= 80) {
            setGradeColor(gradeSuccess3)
            setFeedback(feedbackArr[2].message)
            if(data[0].children != undefined && data[1].children != undefined) {
                if(data[0].children[0].name != undefined && data[1].children[0].name != undefined) {
                    setChips([
                        {
                            name: data[0].children[0].name
                        },
                        {
                            name: data[1].children[0].name
                        },
                    ])
                } else {
                    // setChips([{name: data[0].name}])
                    setChips([])
                }
            } else {
                // setChips([{name: data[0].name}])
                setChips([])
            }
        }
        if(gradePercentage <= 70) {
            setGradeColor(gradeWarning)
            setFeedback(feedbackArr[3].message)
            if(data[0].children != undefined && data[1].children != undefined) {
                if(data[0].children[0].name != undefined && data[0].children[1].name != undefined && data[1].children[0].name != undefined) {
                    setChips([
                        {
                            name: data[0].children[0].name
                        },
                        {
                            name: data[0].children[1].name
                        },
                        {
                            name: data[1].children[0].name
                        },
                    ])
                } else {
                    // setChips([{name: data[0].name}])
                    setChips([])
                }
            } else {
                // setChips([{name: data[0].name}])
                setChips([])
            }
        }
        if(gradePercentage <= 60) {
            setGradeColor(gradeWarning2)
            setFeedback(feedbackArr[4].message)
            if(data[0].children != undefined && data[1].children != undefined) {
                if(data[0].children[0].name != undefined && data[0].children[1].name != undefined && data[1].children[0].name != undefined && data[1].children[1].name != undefined && data[1].children[2].name != undefined) {
                    setChips([
                        {
                            name: data[0].children[0].name
                        },
                        {
                            name: data[0].children[1].name
                        },
                        {
                            name: data[1].children[0].name
                        },
                        {
                            name: data[1].children[1].name
                        },
                        {
                            name: data[1].children[2].name
                        },
                    ])
                } else {
                    // setChips([{name: data[0].name}])
                    setChips([])
                }
            } else {
                // setChips([{name: data[0].name}])
                setChips([])
            }
        }
        if(gradePercentage <= 50) {
            setGradeColor(gradeWarning3)
            setFeedback(feedbackArr[5].message)
            if(data[0].children != undefined && data[1].children != undefined) {
                if(data[0].name != undefined && data[1].children[0].name != undefined && data[1].children[1].name != undefined && data[1].children[2].name != undefined) {
                    setChips([
                        {
                            name: data[0].name
                        },
                        {
                            name: data[1].children[0].name
                        },
                        {
                            name: data[1].children[1].name
                        },
                        {
                            name: data[1].children[2].name
                        },
                    ])
                } else {
                    // setChips([{name: data[0].name}])
                    setChips([])
                }
            }
        }
        if(gradePercentage < 40){
            setGradeColor(gradeFail)
            setFeedback(feedbackArr[6].message)
            if(data[0].name != undefined && data[1].name != undefined){
                setChips([
                    {
                        name: data[0].name
                    },
                    {
                        name: data[1].name
                    },
                ])
            } else {
                // setChips([{name: data[0].name}])
                setChips([])
            }

        }

    }, [gradePercentage])
        

    const generateNewValues = () => {
        setGradePercentage(parseInt(Math.random() * (max - min) + min));
    }



return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justify="center"
      style={{ marginBottom: "30px" }}
    >
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress 
            variant="determinate" 
            value={gradePercentage} 
            size="20rem" 
            style={{  
                borderRadius: "100%",
                color: `${gradeColor + ", 0.8)"}`,
                boxShadow: `inset 0 0 0 1.65rem ${gradeColor + ", 0.2)"}`,
                backgroundColor: "transparent"
            }}

        />
        <Box
            sx={{
            top: -30,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            }}
        >
            <Typography variant="caption">
            {feedback}
            </Typography>
            
     
        </Box>
        <Box
            sx={{
            top: 15,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            }}
        >
     

            <Typography variant="caption">
            {`${gradePercentage}%`}
            </Typography>
        </Box>
        </Box>
        
        {chips.length > 0 ? (
        <>
    <Typography style={{ marginTop: "40px" }} variant="caption">
            You may want to study the following in further detail:
            </Typography>
          
                <>
                <Stack direction="row" spacing={1} style={{ margin: "40px 0 40px 0" }}>
             {chips.map((d, index) => (
                        // <div style={{ display: "block", marginLeft: "auto", marginRight: "auto" }}>

                        <Chip
                            key={index}
                            // style={{ alignItems: "center", textAlign: "center", marginLeft: "auto", marginRight: "auto" }}
                            label={d.name}
                            color="info"
                        />
                        // </div>

                        ))}
                   </Stack>
    
            
                </>
      
        </> 
        ) : (
            <div>

            </div>  
        )}
        <Button onClick={() => generateNewValues()}>Generate new values</Button>
      
      
    </Grid>
  );
};

export default StudentGrading;